import React from 'react';

import Tooltip from '@repo/editor/src/components/Tooltip/Tooltip';
import {
  TooltipAlignment,
  TooltipPlacement,
} from '@repo/editor/src/components/Tooltip/types';
import InfoThickIcon from '@repo/ui/components/Icon/InfoThickIcon';
import { P2, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { FlexColumn } from 'styles/layouts';

import { ComparisonItem } from './styles';
import { tooltipIconTheme } from './theme';
import { RowTitleProps } from './types';

const RowTitle: React.FC<RowTitleProps> = ({ label, subtitle, tooltip }) => {
  return (
    <ComparisonItem isKey>
      <Tooltip
        align={TooltipAlignment.Start}
        placement={TooltipPlacement.Top}
        text={tooltip}
      >
        <div>
          <InfoThickIcon height="15px" theme={tooltipIconTheme} />
        </div>
      </Tooltip>
      <FlexColumn>
        <P2>{label}</P2>
        {subtitle && <P3 color={themeStyle.varInkMedium}>{subtitle}</P3>}
      </FlexColumn>
    </ComparisonItem>
  );
};

export default RowTitle;
